import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MemberNoteService } from 'src/app/project-display/data-access/member-note.service';
import { IProjectNote } from 'src/app/project-display/interfaces/IProjectNote';

interface UpdateMemberNoteDialogData {
  memberNote: IProjectNote;
}

@Component({
  selector: 'eic-update-member-note-dialog',
  templateUrl: './update-member-note-dialog.component.html',
  styleUrl: './update-member-note-dialog.component.scss'
})
export class UpdateMemberNoteDialogComponent {
  readonly maxNoteLength = 999;
  isSaving = false;

  constructor(
    private dialogRef: MatDialogRef<UpdateMemberNoteDialogComponent>,
    private memberNoteService: MemberNoteService,
    @Inject(MAT_DIALOG_DATA) public data: UpdateMemberNoteDialogData
  ) {
  }

  get charsLeft(): number {
    return this.maxNoteLength - (this.data.memberNote?.note?.length ?? 0);
  }

  get canSave(): boolean {
    return !!(this.data.memberNote?.note || '').trim().length && !this.isSaving;
  }

  cancel() {
    this.dialogRef.close();
  }

  update() {
    if (!this.canSave) return;

    this.isSaving = true;
    this.memberNoteService
      .update(this.data.memberNote.projectNoteID, this.data.memberNote)
      .subscribe({
        next: () => this.dialogRef.close(this.data.memberNote),
        error: () => {
          this.isSaving = false;
        }
      });
  }
}
